import React, { useEffect, useState } from "react";

import { HeroShelfzone } from '../../components';
import { HalfColText } from '../../components';
import { HalfColTextFlex } from '../../components';
import { RowQuotes } from '../../components';
import { Loader } from '../../components';
import { PartnershipRow } from '../../components';
import { VideoFullSection } from '../../components';
import { VideoScrollYoutube } from '../../components';
import { HomeColumns } from '../../components';
import { GridShelfzone } from '../../components';
import { BigTextCenter } from '../../components';
import { useSelector } from "react-redux";
import { Banner } from '../../components';
import { BaseUrl } from "../../config";

const ShelfzoneContainer = () => {
  const [quotesArray, setQuotesArray] = useState([]);
  const listPartners = [
    require('../../assets/tech/carousel_logos/1.AWS.png'),
    require('../../assets/tech/carousel_logos/2.Azure.png'),
    require('../../assets/tech/carousel_logos/3.DELL.png'),
    require('../../assets/tech/carousel_logos/4.HP.png'),
    require('../../assets/tech/carousel_logos/5.INCREDIBUILD.png'),
    require('../../assets/tech/carousel_logos/6.OCULUS.png'),
    require('../../assets/tech/carousel_logos/7.mindmedia.png'),
    require('../../assets/tech/carousel_logos/8.nvdia.png'),
    require('../../assets/tech/carousel_logos/9.Sketchfab.png'),
    require('../../assets/tech/carousel_logos/10.Stereolabs.png'),
    require('../../assets/tech/carousel_logos/11.Tobii.png'),
    require('../../assets/tech/carousel_logos/12.Unity.png'),
    require('../../assets/tech/carousel_logos/13.Unreal.png'),
    require('../../assets/tech/carousel_logos/14.Varjo.png'),
    require('../../assets/tech/carousel_logos/15.VIVE.png')
  ]

  const heroImg = require('../../assets/tech/tech-hero.jpg');

  const loader = useSelector((state) => state.loader);

  const arrayLoad = [
    heroImg,
    ...listPartners
  ]

  const columnsEntries = [
    {
      title: 'Build',
      text: 'Simply edit your planograms and store layouts thanks to your assets and 3D SKUs library; set up product categories with filters and KPIs. Once built, render your projects in virtual reality with the utmost realism, with just one click.'
    },
    {
      title: 'Test',
      text: 'Observe the shopper behavior in the VR simulation, collecting and analyzing data through biometric and neuroscientific devices (eye-tracking, EEG, GSR).'
    },
    {
      title: 'Showcase',
      text: 'Share your projects with your stakeholders and partners, in-person or remotely.'
    }
  ]

  useEffect(() => {
    document.title = "Shelfzone"
    fetch(`${BaseUrl}/feedbacks?key=invrsion`, {
      method: 'GET'
    })
    .then(response => {
      return response.json()
      
    }).then((json) =>  {
      setQuotesArray(json.data.feedbacks);
    })
    
  }, [])
  return (
    <React.Fragment>
      
        <section className="shelfzone">
          <HeroShelfzone loaded={loader}/>
          <VideoFullSection 
            bgColor="#333333"
            title="Take your work to another dimension."
            black="#ffffff"
            extraTopPadding={false}
            extraBottom={false}
            noMarginBottom={false}
            align="left"
            zIndex={2}
            noPaddingParent={true}
            supTitle="The Product"
            text="Shelfzone gives you the power to build your own store from scratch and <b>CONDUCT</b> category management, trade
marketing and brand research <b>ACTIVITIES</b>; empowering collaboration across your teams, organization and customers,
saving time and costs."
          >
            <VideoScrollYoutube 
              idScroll="video-shelf-01" 
              align="left"
              idVideo="KGPmUSpulfE"
            />
          </VideoFullSection>
        </section>
        <BigTextCenter title="What can Shelfzone help you do?" subtitle="Our easy-to-use Software as a Service solution puts brands and retailers in full control of the projects, giving you the only tool you’ll need to autonomously build, test and showcase your work, anywhere, at any time." />
        <HomeColumns entries={columnsEntries} separators={true} />
        <GridShelfzone />
        <PartnershipRow
          arrayPartners={listPartners} 
          title="Trusted by" 
        />
        <HalfColText >
          <div className="title--col">
            
          </div>
          {
            quotesArray.length > 0 &&
            <HalfColTextFlex>
              {
                quotesArray.map((key, index) => {
                  return <RowQuotes key={index} quote={key.quote} name={key.name} company={key.company} position={key.company_role} />
                })
              }
            </HalfColTextFlex>
          }
        </HalfColText>
        <Banner 
          text="Build, test, and showcase your projects with Shelfzone, today." 
          route="/reach-out" 
          copyRoute="Get started"
        />
        <Loader arrayLoad={arrayLoad} />
      
    </React.Fragment>
  );
};

export default ShelfzoneContainer;